import { call, put, takeEvery } from '@redux-saga/core/effects';
import { SAVE_NEW_CUSTOMER, UPDATE_CUSTOMER } from '../actions/actionsTypes';
import { patchDataWithHeaders, postNewCustomerWithHeaders } from '../httpClient';
import camelcaseKeys from 'camelcase-keys';
import { SaveNewCustomerActionType } from '../actions/newCustomerAction';
import { setCustomer } from '../slices/customerSlice/customerSlice';
import { resetUser } from '../slices/userSlice/userSlice';
import { SaveUpdateActionType } from '../actions/updateCustomerAction';

export function* saveUpdateCustomer(action: SaveUpdateActionType): any {
  try {
    const response = yield call(patchDataWithHeaders, `/api/v1/customers/${action.id}`, action.headers, {
      first_name: action.firstName,
      last_name: action.lastName,
      phone_number: action.phoneNumber,
      email: action.email,
    });
    yield put(setCustomer(camelcaseKeys(response)));

    action.navigate(`/customer?id=${response.id}`);
  } catch (e) {
    yield put(resetUser());
    alert('Sorry, Login Expired! Please Login again');
    action.navigate('/login');
  }
}

export function* watchSaveUpdateCustomer() {
  yield takeEvery(UPDATE_CUSTOMER, saveUpdateCustomer);
}
